import { Button, Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";
import { DEVICE_MAX } from "../../../../constants/responsive";

export const TextPendingMonth = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-2, #616161);
    text-align: center;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;

export const OpenCard = styled(Flex)`
    width: clamp(180px, 100%, 235px);
    max-width: 235px;
    flex-grow: 1;
    height: 224px;
    border: 1px solid var(--border);
    border-radius: 8px;
    overflow: hidden;
    background: white;
    opacity: ${({ opacity }) => (opacity ? opacity : "100%")};

    /* <= 425px : une colonne, carte pleine largeur */
    @media ${DEVICE_MAX.mobile} {
        width: 100%;
        max-width: none;
        min-width: 0;
    }
`;

export const Header = styled(Flex)`
    /* margin: 8px; */
    min-height: 44px;
    width: 100%;
    padding: 8px;
    border-radius: 8px 8px 0px 0px;
    border: 1px solid ${({ border }) => (border ? border : "yelow")};
    background: ${({ headerBackground }) =>
        headerBackground ? headerBackground : "yellow"};
`;

export const MonthName = styled(Text)`
    text-transform: capitalize;
    color: ${({ monthNameColor }) =>
        monthNameColor ? monthNameColor : "yellow"};
    text-align: center;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;

    /* height: 33px; */
    /* padding: 0px 16px; */
`;

export const IndisponibleText = styled(Text)`
    color: #616161;

    font-weight: 400;
    opacity: 50%;
    font-size: 16px;
    font-style: italic;
`;
export const InProgressText = styled(Text)`
    color: #242424;

    font-size: 16px;
    font-style: italic;
`;

export const Content = styled(Flex)`
    width: 131px;
    margin-top: 20px;
    gap: 12px;
`;
export const HoursworkedPerMonth = styled(Text)`
    /* color: #242424;

    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px; 133.333% */

    font-size: 26px;
    font-weight: 600;
    color: var(--text);
`;
export const WeekDetail = styled(Button)`
    font-size: 14px;
    color: var(--purple);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    &:hover {
        text-decoration: underline;
    }
`;
export const HeaderDialogText = styled(Text)`
    color: #424242;

    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
`;
